import "@/App.css";
import { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LoadingScreen } from "@/components/LoadingScreen";
import { CookieNotice } from "@/components/CookieNotice";
import DragonsLanding from "@/pages/DragonsLanding";

function App() {
  const [showLoader, setShowLoader] = useState(true);
  const hideLoader = useCallback(() => setShowLoader(false), []);

  return (
    <div className="App noise-bg">
      {showLoader ? <LoadingScreen onFinish={hideLoader} /> : null}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DragonsLanding />} />
        </Routes>
      </BrowserRouter>
      <CookieNotice />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
